import React, { FC, useRef } from 'react'
import s from './PromoRollCardDefault.module.sass'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { TypePromoItemDefault } from '@features/PromoRoll/types/types'
import Link from 'next/link'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'

interface Props {
  data: TypePromoItemDefault
  className?: string
  onClick: () => void
}

const PromoRollCardDefault: FC<Props> = ({ data, onClick, className = '' }) => {
  const { isMobile } = useClientResponsive()

  return (
    <ErrorBoundary>
      <Link
        href={data.href}
        className={className}
        target='_blank'
        onClick={onClick}
        scroll={false}
        title={data.description}>
        <img
          src={isMobile ? data.src.mobile : data.src.desktop}
          alt={data.description}
          width={isMobile ? 267 : 402}
          height={isMobile ? 96 : 140}
        />
      </Link>
    </ErrorBoundary>
  )
}

export default PromoRollCardDefault
